import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Plus } from 'lucide-react';
import { SectionLabel, Reveal } from '../Section';

const FAQS = [
  {
    q: 'What is KROY Esports?',
    a: 'KROY Esports (Kannadiga Royals Esports) is an Indian competitive mobile esports platform for BGMI and Free Fire. Players join daily tournaments, climb leaderboards and win real money prizes — all from their phone.',
  },
  {
    q: 'How do I join a tournament?',
    a: 'Download the app, create your account, open the Arena, pick any live or upcoming tournament and register your slot. Room ID and password appear inside the app before match time.',
  },
  {
    q: 'Is the app free to download?',
    a: 'Yes — KROY Esports is completely free to download on Android and iOS, and many tournaments have free entry too.',
  },
  {
    q: 'How are prizes distributed?',
    a: 'Once match results are verified by our tournament admins, prizes are credited automatically to the winners. No manual claims, no chasing support.',
  },
  {
    q: 'How does the Winning Vault work?',
    a: 'The Winning Vault is your secure in-app wallet. Every prize you win is stored there safely and becomes withdrawable after a short maturity period as per our refund policy.',
  },
  {
    q: 'Is BGMI required to play?',
    a: 'You need BGMI installed for BGMI tournaments and Free Fire for Free Fire tournaments. The KROY app handles registrations, rooms, scores and payouts — the matches happen in-game.',
  },
  {
    q: 'How do I withdraw my winnings?',
    a: 'Open your Winning Vault in the app, tap Withdraw, enter your UPI or bank details and submit. Withdrawals are processed quickly after verification.',
  },
];

export default function Faq() {
  const [openIdx, setOpenIdx] = useState(null);

  return (
    <section id="faq" className="py-20 sm:py-28 bg-[#0a0a0a]" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-5 sm:px-8">
        <SectionLabel testid="faq-label">Frequently Asked Questions</SectionLabel>
        <Reveal>
          <h2 className="mt-5 font-display text-white text-3xl sm:text-5xl">
            Got questions? <span className="text-[#e8173a]">Answered.</span>
          </h2>
        </Reveal>
        <div className="mt-12 space-y-3">
          {FAQS.map((f, i) => {
            const open = openIdx === i;
            return (
              <Reveal key={f.q} delay={i * 0.04}>
                <div
                  data-testid={`faq-item-${i}`}
                  className={`card-surface overflow-hidden transition-colors duration-300 ${open ? 'border-[#e8173a]/40' : ''}`}
                >
                  <button
                    data-testid={`faq-question-${i}`}
                    onClick={() => setOpenIdx(open ? null : i)}
                    className="w-full flex items-center justify-between gap-4 px-5 sm:px-6 py-5 text-left"
                  >
                    <span className="text-white font-semibold text-sm sm:text-base">{f.q}</span>
                    <motion.span
                      animate={{ rotate: open ? 45 : 0 }}
                      transition={{ duration: 0.3 }}
                      className={`shrink-0 w-7 h-7 rounded-full flex items-center justify-center ${open ? 'bg-[#e8173a]' : 'bg-[#e8173a]/15'}`}
                    >
                      <Plus className="w-4 h-4 text-white" strokeWidth={2.8} />
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false}>
                    {open && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                      >
                        <p className="px-5 sm:px-6 pb-6 text-sm text-[#9e9e9e] leading-relaxed" data-testid={`faq-answer-${i}`}>
                          {f.a}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
